export abstract class EdwinService {}
